/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * SetupIntentResponseBase
 * auto generated base class for the model SetupIntentResponseModel.
 */
export const SetupIntentResponseModelBase = ModelBase.named('SetupIntentResponse')
  .props({
    __typename: types.optional(types.literal('SetupIntentResponse'), 'SetupIntentResponse'),
    clientSecret: types.union(types.undefined, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class SetupIntentResponseModelSelector extends QueryBuilder {
  get clientSecret() {
    return this.__attr('clientSecret')
  }
}
export function selectFromSetupIntentResponse() {
  return new SetupIntentResponseModelSelector()
}

export const setupIntentResponseModelPrimitives = selectFromSetupIntentResponse().clientSecret
